<template>

    <div class="users-style">

      <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
          <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Roster Management</span>
      </h4>
      <div class="ibox px-3 py-4 mt-4">
        <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
              <h4 class="clearfix mb-0">
                  <span class="float-left">Roster Management
                      <span class="title-sub-text"></span>
                  </span>
                  <span class="float-right"></span>
              </h4>
          </div>

        <div class="clearfix row py-2 mb-2 ">          
          <div class="col-sm-6">
            <div class="custom-search w-100">
              <b-input-group class="mb-0">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
              </b-input-group>
            </div>
          </div>
          <div class="col-sm-6 float-right text-right px-3">
            <b-button id="show-btn" class="" @click="addModal"><b-icon icon="plus" ></b-icon> Create Roster</b-button>
          </div>
        </div>

        <div v-if="error" class="alert alert-danger mb-2">{{ error }}</div>

        <div class="table-responsive employee-table-wrapper pb-0">
          <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
            <thead class="table-head">
            <tr>
              <th>Roster Name</th>
              <th>Work Location</th>
              <th>Department</th>
              <th>
                <label class="custom-label mb-0">
                  <p class="mb-0">Start Date</p>
                  <div class="table-header">
                      <div class="table sub-header mb-0">(YYYY-MM-DD)</div>
                  </div>
                </label>
              </th>
              <th>
                <label class="custom-label mb-0">
                  <p class="mb-0">End Date</p>
                  <div class="table-header">
                      <div class="table sub-header mb-0">(YYYY-MM-DD)</div>
                  </div>
                </label>
              </th>
              <th>Shift Count</th>
              <th>Assigned Head Count</th>
              <th class="text-right">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading">
              <td colspan="9" class="text-center text-muted hover-bg table-row border-bottom mx-2">Loading…</td>
            </tr>
            <tr v-else v-for="(s, index) in paginatedData" :key="s.id" class="hover-bg table-row border-bottom mx-2">
              <td>{{ s.name }}</td>
              <td>{{ s.branch }}</td>
              <td>{{ s.department }}</td>
              <td>{{ moment(s.period_start).format('YYYY-MM-DD') }}</td>
              <td>{{ moment(s.period_end).format('YYYY-MM-DD') }}</td>
              <td class="text-right">
                <b-button variant="link" v-b-tooltip.hover.top="'Click to view'" @click="showShiftListModal(s)"><strong>{{ s.shifts }}</strong> Shift(s)</b-button>
              </td>
              <td class="text-right">
                <b-button variant="link" v-b-tooltip.hover.top="'Click to view'" @click="showEmployeeListModal(s, s.employees)"><strong>{{ s.employee_count }}</strong> Employee(s)</b-button>
              </td>
              <td class="text-right">

                <div class="action">
                  <b-button-toolbar class="float-right position-relative">
                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                      <b-button-group class="">
                        <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Roster" @click="editRoster(s.id)">
                          <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                        </b-button>
                        <b-button class="border-0 rounded py-0" variant="outline-secondary" v-if="s.employee_count == 0" title="Delete Roster" @click="remove(s.id)">
                          <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                        </b-button>
                        <b-button class="border-0 rounded py-0" variant="outline-secondary" title="View Assigned Employees" v-if="s.employee_count > 0" @click="showEmployeeListModal(s, s.employees)">
                          <b-icon icon="people" aria-hidden="true"></b-icon> View Assigned Employees
                        </b-button>
                      </b-button-group>
                    </div>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
          <div v-else class="px-3 mt-4">
            <ul class="pagination b-pagination float-left mb-0 mt-1">
              <li class="page-item disabled m-2">View</li>
              <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
              <li class="page-item disabled m-2">per page. Total {{rosters.length}} records found.</li>
            </ul>
            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

          </div>
        </div>


      </div>



        <b-modal id="bv-create-roster-modal" :title="modalTitle" size="lg" ok-variant="primary" hide-footer :busy="saving" :no-close-on-esc="saving" :no-close-on-backdrop="saving">
          <b-overlay :show="submitting">
            <b-form @submit.stop.prevent="submit">

              <b-form-row>

                <b-col cols="12">
                  <b-form-group label="Roster Name" label-for="name" class="required-field">
                    <b-form-input id="name" name="name" v-model.trim="fdata.name" v-validate="{ required: true, min: 3, regex: /^[A-Za-z&()\/,_.\- ]+$/ }" data-vv-as="Roster Name" :state="validateState('name')" placeholder="Roster" aria-describedby="name-feedback"/>
                    <b-form-invalid-feedback id="name-feedback" v-if="veeErrors.has('name')">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                  </b-form-group>

                </b-col>
                <b-col cols="6">
                  <b-form-group label="Work Location" label-for="branch_id">
                    <b-input-group>
                      <b-form-select :disabled="!canEdit" id="branch_id" v-model="fdata.branch_id" :options="branchOptions">
                        <template #first>
                          <b-form-select-option :value="null">All Work Location</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Department" label-for="department_id">
                    <b-input-group>
                      <b-form-select :disabled="!canEdit" id="department_id" v-model="fdata.department_id" :options="departmentOptions">
                        <template #first>
                          <b-form-select-option :value="null">All Department</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>

              <b-form-row class="mb-3">

                <b-col cols="6">
                  <b-form-group id="period_start-group" label-for="period_start" class="required-field mb-0">
                    <template #label>
                      Period Start Date
                      <b-icon v-b-tooltip.top.hover="'This marks the starting point of the roster period.'" icon="info-circle" variant="info"></b-icon>
                    </template>
                    <b-input-group class="mb-0">
                      <b-form-input :disabled="!canEdit" id="period_start" name="period_start" v-model="fdata.period_start" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                    autocomplete="off" :state="validateState('period_start')" aria-describedby="period_start-feedback" data-vv-as="Period Start Date"/>
                      <b-input-group-append class="mb-0">
                        <b-form-datepicker :disabled="!canEdit" :min="`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-01`"
                                          class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.period_start" />
                      </b-input-group-append>
                      <b-form-invalid-feedback id="period_start-feedback">
                        {{ veeErrors.first('period_start') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group id="period_end-group" label-for="period_end" class="required-field mb-0">
                    <template #label>
                      Period End Date
                      <b-icon v-b-tooltip.top.hover="'This marks the end of the roster period (how long the roster will continue).'" icon="info-circle" variant="info"></b-icon>
                    </template>
                    <b-input-group class="mb-0">
                      <b-form-input :disabled="!canEdit" id="period_end" name="period_end" v-model="fdata.period_end" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                    autocomplete="off" :state="validateState('period_end')" aria-describedby="period_end-feedback" data-vv-as="End Date"/>
                      <b-input-group-append class="mb-0">
                        <b-form-datepicker :min="fdata.period_start || `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-01`"
                                          :disabled="!canEdit" class="mb-0" id="day_two" button-only right locale="en-US" v-model="fdata.period_end" />
                      </b-input-group-append>
                      <b-form-invalid-feedback id="period_end-feedback">
                        {{ veeErrors.first('period_end') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-form-row>



              <div class="bg-wash rounded px-3 py-4">
            
                <div class="approve-level-content p-0 pb-2 text-center form-group d-flex flex-column border-bottom">
                    <span class="salary-heads text-muted">Shift Rotation Setup</span>
                    <label class="text-muted">Set up shift rotation by selecting shifts and defining the interval days for each shift.</label>
                </div>
                <table class="table table-bordered dataTable">
                  <thead class="table-head">
                  <tr>
                    <th>SL</th>
                    <th>Shift Name</th>
                    <th>Interval (Days) <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="`Days the employee stays in this shift before rotating.`"></b-icon></th>
                    <th v-if="canEdit">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(shift, index) in shifts" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>

                    <td>
                      <b-form-select v-model.number="shift.shift_id" :options="shiftData" :name="`shifts[${index}].shift_id`" v-validate="'required'"
                                    :disabled="!canEdit" :state="validateState(`shifts[${index}].shift_id`)" :aria-describedby="`shift_id-feedback-${index}`" data-vv-as="Shift">
                        <template #first>
                          <option :value="null" disabled>Select a shift</option>
                        </template>
                      </b-form-select>
                      <b-form-invalid-feedback :id="`shift_id-feedback-${index}`" v-if="veeErrors.has(`shifts[${index}].shift_id`)">
                        {{ veeErrors.first(`shifts[${index}].shift_id`) }}
                      </b-form-invalid-feedback>
                    </td>

                    <td>        
                      <div class="w-100">
                          <b-input-group append="Days">
                              <b-form-input
                                  class="flex-grow-1"
                                  v-model="shift.interval_days"
                                  :name="`shifts[${index}].interval_days`"
                                  v-validate="{required: true, numeric: true, min_value: 1}"
                                  :disabled="!canEdit"
                                  :state="validateState(`shifts[${index}].interval_days`)"
                                  :aria-describedby="`interval-feedback-${index}`"
                                  data-vv-as="Interval Days"
                              />
                          </b-input-group>
                          <b-form-invalid-feedback :id="`interval-feedback-${index}`" class="d-block"
                              v-if="veeErrors.has(`shifts[${index}].interval_days`)">
                              {{ veeErrors.first(`shifts[${index}].interval_days`) }}
                          </b-form-invalid-feedback>
                      </div>
                    </td>

                    <td v-if="canEdit" class="text-center">
                      <b-button @click="removeShift(index)" variant="outline-danger" size="sm" class="rounded" :disabled="shifts.length <= 1">
                        <b-icon icon="trash"></b-icon>
                      </b-button>
                    </td>
                  </tr>

                  </tbody>
                </table>

                <div class="d-flex justify-content-end align-items-center form-group">
                  <label class="mr-2 roster-font-weight-regular mb-0">
                    <strong>{{ shifts.length }}</strong> Shift(s) Added
                  </label>
                  <b-button v-if="canEdit" class="custom-wizard-btn" variant="primary" @click="addShift"><b-icon icon="plus"></b-icon> Add Shift</b-button>
                </div>
              </div>

              <div class="d-flex justify-content-center align-items-center gap-2 my-5">
                <b-button type="submit" class="mr-3" variant="primary" :disabled="submitting">
                  {{ fdata.id ? 'Update Roster' : 'Create Roster' }}
                </b-button>
                <b-button @click="closeModal(false)" variant="secondary" class="custom-wizard-btn">Cancel</b-button>
              </div>
            </b-form>
          </b-overlay>
        </b-modal>

        <b-modal id="bv-show-roster-shifts-modal" hide-footer :title="'Assigned Shifts to '  + (selectedRoster!=null ? selectedRoster.name : '')">
          <div class="table-responsive employee-table-wrapper">
            <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
              <thead class="table-head">
                <tr>
                  <th>SL</th>
                  <th>Shift Name</th>
                  <th>Interval Days</th>
                </tr>
              </thead>
              <tbody>
                <tr class="hover-bg table-row border-bottom mx-2" v-for="(shift, index) in shiftListModal">
                  <td>{{ index+ 1}}</td>
                  <td>
                    <span class="badge shift-list-badge" :style="{ background: shift.color + '22', color: shift.color }">
                      {{ shift.shift_name }}
                    </span>
                  </td>
                  <td>{{ shift.interval_days }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-modal>

        <b-modal id="bv-show-roster-employees-modal" hide-footer size="xl">
          <template #modal-title>
            Assigned Employees to <strong>{{ selectedRoster != null ? selectedRoster.name : '' }}</strong>
          </template>
          <div id="roster-employees-modal">
            <common-list :checkbox="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="employeeListModal"
                        :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
          </div>
        </b-modal>
  </div>
</template>

<script>

import moment from "moment";

export default {
  data() {
    return {
      search: '',
      loading: false,
      saving: false,
      error: null,
      rosters: [],
      canEdit: true,
      rosterData:null,
      editData: null,
      selectedRoster:null,
      shifts: [],
      shiftListModal: [],
      list_key: 0,
      employeeListModal: [],
      company_options: [],
      default_column:['name','employee_code','email','department','jobposition', 'branch'],
      appended_column: [
        { value: "off_day", text: "Off Day", type: "text" },
      ],
      shiftData: [],
      departmentData: [],
      branchData: [],
      submitting: false,
      fdata: {
        id: 0,
        name: '',
        period_start: '',
        period_end: '',
        department_id: null,
        branch_id: null,
      },
      modalTitle: 'Create New Roster',
      pagination: {currentPage: 1, pages:1},
      length_options:
          [
            { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 500, text: "500" },
            { value: 1500, text: "1500" },
          ],
      temp_length: 20,
    }
  },
  computed: {
    departmentOptions() {
      return this.departmentData.map(dept => ({
        value: dept.id,
        text: dept.name || `Department ${dept.id}`
      }));
    },
    branchOptions() {
      return this.branchData.map(dept => ({
        value: dept.id,
        text: dept.name || `Work Location ${dept.id}`
      }));
    },
    filteredData()
    {
      let filtered_list = this.rosters;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
      }
      return filtered_list;
    },
    paginatedData()
    {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },

  },
  created() {
    this.loadData();
    this.loadRosterData();
  },
  methods: {
    moment,
    listReturn(){},
    closeModal(){
      this.$bvModal.hide('bv-create-roster-modal');
    },
    showShiftListModal(roster){
      this.selectedRoster = roster
      axios.get(this.$api_url + '/leave-attendance/edit/' + roster.id).then(response=>{
        this.shiftListModal = response.data.shifts;
        this.$bvModal.show('bv-show-roster-shifts-modal');
      });
    },
    showEmployeeListModal(roster,employee_ids){
      this.selectedRoster = roster;
      axios.get(this.$api_url + '/leave-attendance/employees/list', {
        params: {
          fields:'offday,roster,shift',
          employee_ids: JSON.stringify(employee_ids)
        }
      }).then(response=>{
        this.employeeListModal = response.data.employee_data;
        this.company_options = response.data.options;
        this.$bvModal.show('bv-show-roster-employees-modal');
      });
    },
    addModal(){
      this.editData = null;
      this.canEdit = true;
      this.modalTitle = 'Create New Roster';
      this.resetForm();
      this.$bvModal.show('bv-create-roster-modal');
    },

    editRoster(rosterId){
      this.modalTitle = 'Edit Roster';
      axios.get(this.$api_url + '/leave-attendance/edit/' + rosterId).then(response=>{
        this.editData = response.data;
        this.fdata.id = this.editData.id;
        this.fdata.name = this.editData.name;
        this.fdata.period_start = this.editData.period_start;
        this.fdata.period_end = this.editData.period_end;
        this.fdata.department_id = Number(this.editData.department_id) || null;
        this.fdata.branch_id = Number(this.editData.branch_id) || null;

        if (Array.isArray(this.editData.shifts) && this.editData.shifts.length) {
          this.shifts = this.editData.shifts.map(s => ({
            shift_id: Number(s.shift_id) || null,
            interval_days: Number(s.interval_days) || 1
          }));
        } else {
          this.addShift();
        }
        this.canEdit = (this.rosters.find(({id}) => rosterId == id)).employee_count == 0;
        this.$bvModal.show('bv-create-roster-modal')
      })
    },


    remove(id) {
      this.$bvModal.msgBoxConfirm('Delete this roster?', {
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true,
      }).then(ok => {
        if (!ok) return
        axios.post(`/leave-attendance/delete/${id}`).then(() => {
          this.$bvToast.toast('Roster deleted.', { variant: 'success', solid: true , title: 'Success'})
          this.loadRosterData();
          this.loadData()
        }).catch(e => {
          this.serverError(e);
        });
      })
    },

    loadRosterData() {
      this.loading = true
      this.error = null
      axios.get('/leave-attendance/list').then(({ data }) => {
        this.rosters = data;
        this.loading = false;
      })
      .catch(e => {
        this.serverError(e);
      });
    },

    addShift() {
      this.shifts.push({ shift_id: null, interval_days: 1 });
    },
    removeShift(index) {
      if (this.shifts.length > 1) this.shifts.splice(index, 1);
    },
    loadData() {
      axios.get(this.$api_url + '/branch/list').then(response => {
        this.branchData = response.data;
      });
      axios.get(this.$api_url + '/department/list').then(deptResponse => {
        this.departmentData = deptResponse.data;
        axios.get('/leave-attendance/shifts', {params: {type: 'list'}}).then(shiftResponse => {
          this.shiftData = shiftResponse.data;
        }).catch(e => this.serverError(e));
      }).catch(e => this.serverError(e));

    },
    resetForm(){
      this.fdata = {
        id: 0,
        name: '',
        period_start: '',
        period_end: '',
        department_id: null,
        branch_id: null,
      };
      this.shifts = [{ shift_id: null, interval_days: 1 }];
    },

    submit() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }
        this.submitting = true;

        const payload = {
          id: this.fdata.id || undefined,
          name: this.fdata.name,
          department_id: this.fdata.department_id,
          branch_id: this.fdata.branch_id,
          period_start: this.fdata.period_start,
          period_end: this.fdata.period_end,
          shifts: this.shifts.map(s => ({
            shift_id: s.shift_id,
            interval_days: s.interval_days
          }))
        };
        axios.post(this.$api_url + '/leave-attendance/save', payload).then(response => {
          this.$bvToast.toast(
              this.fdata.id ? 'Roster updated successfully!' : 'Roster created successfully!',
              { variant: 'success', solid: true }
          );

          this.closeModal();
          this.loadRosterData();
          this.resetForm();
          this.submitting = false;
        }).catch(e => {
          this.serverError(e);
          this.submitting = false;
        });
      })


    },

    validateState(ref) {
      try {
        if (this.veeErrors && typeof this.veeErrors.has == 'function') {
          return this.veeErrors.has(ref) ? false : null;
        }
      } catch (_) {}
      return null;
    },

  },
}
</script>
